// extracted by mini-css-extract-plugin
export var fullHeight = "Hero-module--fullHeight--D3wJ4";
export var hasAltShape = "Hero-module--hasAltShape--7r3mm";
export var hero = "Hero-module--hero--ju5NP";
export var heroPicture = "Hero-module--heroPicture--Idnri";
export var heroText = "Hero-module--heroText--ctou-";